/* unplugin-vue-components disabled */import script from "./LoungePage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoungePage.vue?vue&type=script&setup=true&lang=js"

import "./LoungePage.vue?vue&type=style&index=0&id=1f382888&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f382888"]])

export default __exports__